/* eslint-disable react-hooks/exhaustive-deps */ // TODO: remove it
import _ from 'lodash'
import classNames from 'classnames'
import {
  createContext,
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
  useReducer,
  useCallback,
  useRef,
} from 'react'
import { GPCS_CONTAINERS, PRISMA_ACCESS_KEY, SWG_CONTAINER } from './ui-lib/constants'
import { Collapse } from 'reactstrap'
import history from '../../framework/history'
import caretDown from './ui-lib/images/chevron-down-menu.svg'
import caretUp from './ui-lib/images/chevron-up-menu.svg'
import NavErrorBoundary from '../common/NavErrorBoundary'
import { isValidRoute, renderTitle, saveUserPreferencePromise } from './ui-lib/utils'
import { RouteContext } from './RouteContext'
import { _T } from '../../i18n'
import './LeftNav.scss'

export const debounceSave = _.debounce((userPre) => {
  saveUserPreferencePromise(userPre)
}, 3000)

const savePreference = (main, state) => {
  const pref = _.get(main, 'loggedInUser.preference')
  const userPref = pref ? _.cloneDeep(pref) : {}
  _.set(userPref, 'config.favorites', state.favorites)
  debounceSave(userPref)
}

const reducer = (state, action = {}) => {
  const newState = _.cloneDeep(state)
  const { type, key, value, isSelected, main, payload } = action
  switch (type) {
    case 'SET_USER_PREFERENCE_FAVORITES': {
      let favoritesList = _.get(newState, `favorites.${key}`, [])
      favoritesList = favoritesList.filter((fav) => {
        return fav.path !== value?.path
      })
      !isSelected && favoritesList.push(value)
      _.set(newState, `favorites.${key}`, favoritesList)
      savePreference(main, newState)
      return newState
    }
    case 'INIT': {
      const favorites = payload.favorites
      Object.keys(favorites).forEach((key) => {
        favorites[key] = favorites[key].filter((item) => {
          return item?.path?.startsWith('/manage') //in new management, route that can be favorite starts with manage.
        })
      })
      newState.favorites = favorites
      return newState
    }
    default: {
      return state
    }
  }
}

let idCounter = 1
const menuHistory = {}
const queryHistory = {}
const MANAGE_ROOT_PATH = '/manage/'
let goToFirstLink = true

const MenuContext = createContext({})
const useUniqueId = (prefix = '') => `${prefix}/${useMemo(() => idCounter++, [prefix])}`

const LeftNav = ({
  item = {},
  level = 0,
  id = '',
  parentArray = [],
  favorites,
  showFavorites,
  isFavList,
  main,
  pathAvailMap,
  pathDisabledMap,
  favoriteState,
  dispatch,
}) => {
  id = useUniqueId(id)
  const {
    goTo,
    expandedId,
    setExpandedId,
    removeExpandedId,
    locationRoute,
    menuKey,
    isFavClickedPath,
    setIsFavClickedPath,
    selectedItem,
  } = useContext(MenuContext)
  const { children, title, isSetup, callAvail, expandable } = item
  // avoid avail already there and in readonly state
  if (!item.avail) {
    const mappedAvail = (item.pathAvailMapping && pathAvailMap[item.pathAvailMapping]) ||
      (item.path && item.path !== '#' && pathAvailMap[item.path])
    if (mappedAvail) {
      try {
        item.avail = mappedAvail
      }
      catch (e) {
        item = { ...item, avail: mappedAvail }
      }
    }
  }
  if (item.disabled === undefined) {
    const mappedDisabled = item.path && item.path !== '#' && pathDisabledMap[item.path]
    if (mappedDisabled) {
      try {
        item.disabled = mappedDisabled
      }
      catch (e) {
        item = { ...item, disabled: mappedDisabled }
      }
    }
  }
  const isValid = isValidRoute(item)
  const getTargetLocation = () => { // TODO: remove hardcode logic from framework
    if (item.fixedLocationRoute) return SWG_CONTAINER
    if (locationRoute === SWG_CONTAINER) return PRISMA_ACCESS_KEY
    return locationRoute || PRISMA_ACCESS_KEY
  }
  const getPath = () => {
    if (menuKey === 'manage') { // TODO: remove hardcode logic from framework
      return isSetup ? item.path : `${MANAGE_ROOT_PATH}${getTargetLocation()}${item.path}`
    }
    return item.navPath || item.path
  }
  const itemPath = getPath()
  const isSelected = Boolean(selectedItem?.path) && item.path === selectedItem.path && item.fixedLocationRoute === selectedItem.fixedLocationRoute
  const isExpanded = expandedId.indexOf(id) !== -1
  const handleToggle = () => (!isExpanded ? setExpandedId(id) : removeExpandedId(level))
  const currParentArray = [...parentArray]
  if (item.key || item.title) currParentArray.push(item.key || item.title)
  // favorites = item.showFavorites ? _.get(main, `loggedInUser.preference.config.favorites.${item.key}`) : favorites
  showFavorites = item.showFavorites ? true : showFavorites

  favorites = item.showFavorites ? _.get(favoriteState, `favorites.${item.key}`) : favorites

  const onItemClick = () => {
    if (isFavList) {
      setIsFavClickedPath(item.path)
    }
    else {
      setIsFavClickedPath('')
    }
    goTo(itemPath)
  }
  const getItem = (child, index, isFavList) => child && !child.hidden && ( // hide hidden item
    <LeftNav
      key={`${id}-${index}`}
      item={child}
      parentArray={currParentArray}
      level={level + 1}
      favorites={favorites}
      showFavorites={showFavorites}
      id={id}
      isFavList={_.isBoolean(isFavList) ? isFavList : false}
      pathAvailMap={pathAvailMap}
      pathDisabledMap={pathDisabledMap}
      dispatch={dispatch}
      favoriteState={favoriteState}
      main={main}
    />
  )

  useEffect(() => {
    if (!children && goToFirstLink && isValid && !menuHistory[menuKey]) {
      goTo(itemPath)
      goToFirstLink = false
    }
  }, [menuKey])

  useEffect(() => {
    if (isFavClickedPath !== item.path && isSelected) setExpandedId(id)
  }, [isSelected])

  if ((isSetup || callAvail) && !isValid) {
    return null
  }

  if (!children || (!item.expendable && (item.layout || item.component?.layout))) {
    const currFav = _.find(favorites || [], { path: item.path })
    const isDisabled = item.disabled === true || item.disabled?.() || false
    return (
      <NavErrorBoundary context={item.path || item.key}>
        <li className={`is-link ${currFav ? 'is-fav' : ''}`} data-nav-key={item.key} data-nav-path={item.path}>
          <span className={classNames({ selected: isSelected, disabled: isDisabled })} role='button' onClick={isDisabled ? undefined : onItemClick}>
            {renderTitle(title)}
          </span>
          {showFavorites && !isDisabled && !item.hideCurrentFavOption && (
            <div className={`fav-parent nav-fav ${currFav ? 'selected' : ''}`}>
              <i
                className={`${currFav ? 'selected' : ''} nav-fav-star`}
                onClick={() => {
                  const isSelected = currFav ? true : false
                  dispatch({
                    type: 'SET_USER_PREFERENCE_FAVORITES',
                    key: currParentArray[0],
                    isSelected,
                    main,
                    value: {
                      item,
                      path: item.path,
                      parentArray: currParentArray
                    }
                  })
                }}
              ></i>
              <div className='fav-tooltip'>{`${currFav ? _T('Remove from Favorites') : _T('Add to Favorites')}`}</div>
            </div>
          )}
        </li>
      </NavErrorBoundary>
    )
  }

  if (level === 0) {
    return <ul>{children.map(getItem)}</ul>
  }
  if (expandable && children?.length === 0) {
    return null // skip render parent expandable menu if children is empty
  }
  const [showBeforeFav, remainChildren] = _.partition(children, item => item.showBeforeFavorites)
  return (
    <NavErrorBoundary context={item.path || item.key}>
      <li className={`level-${level} ${isExpanded ? 'expanded' : ''}`} data-nav-key={item.key} data-nav-path={item.path}>
        <div aria-expanded={isExpanded} role='button' onClick={handleToggle}>
          <span>{renderTitle(title)}</span>
          <img className='ml-1' alt={_T('Toggle Menu')} src={isExpanded ? caretUp : caretDown} />
        </div>
        <Collapse className={item.showFavorites ? 'contains-favorites' : ''} isOpen={isExpanded} tag='ul'>
          {showBeforeFav.map(getItem)}
          {item.showFavorites &&
            favorites?.map((fav, index) => getItem(fav.item, index, true))
          }
          {remainChildren.map(getItem)}
        </Collapse>
      </li>
    </NavErrorBoundary>
  )
}

const initialState = {
  favorites: {}
}

const LeftNavWrap = ({ menu = {}, _showSideMenu, main, pathAvailMap, flattenNavigationList }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { updateRouteValue, locationRoute, changeConfigLocation } = useContext(RouteContext)
  const [currentPath, setCurrentPath] = useState('')
  const [selectedItem, setSelectedItem] = useState()
  const [expandedId, setExpandedId] = useState('')
  const [isFavClickedPath, setIsFavClickedPath] = useState('')
  const removeExpandedId = useCallback((level) => {
    setExpandedId(
      expandedId
        .split('/')
        .slice(0, level + 1)
        .join('/'),
    )
  }, [expandedId])

  const [pathDisabledMap, overriddenNavKeys] = useMemo(() => [
    flattenNavigationList.reduce((map, { path, disabled }) => {
      if (disabled && path && path !== '#') {
        map[path] = disabled
      }
      return map
    }, {}),
    flattenNavigationList.reduce((set, item) => {
      if (item.hoistChildren || item.overrideLeftNav?.with === 'children') {
        if (/^\/[\w-]+\/?$/.test(item.path)) {
          set.add(item.path.replace(/\//g, ''))
        }
      }
      return set
    }, new Set([]))
  ], [flattenNavigationList])
  const overriddenNavKeysRef = useRef(overriddenNavKeys)
  overriddenNavKeysRef.current = overriddenNavKeys
  const getKeyFromPath = useCallback((path = '') => {
    const keys = path.split('/', 3).filter(Boolean)
    let key = keys[0]

    if (key === 'overview') { // TODO: remove hardcode logic from framework
      key = 'manage'
    }
    if (overriddenNavKeysRef.current.has(key)) {
      key = `${key}-${keys[1]}`
    }

    return key
  })

  const getSelectedItem = useMemo(() => _.memoize((pathname) => {
    const exactMatch = flattenNavigationList.find(({ path, hidden }) => path === pathname && !hidden)
    if (exactMatch) {
      return exactMatch
    }
    if (!pathname.startsWith(MANAGE_ROOT_PATH)) { // non-fawkes route use new logic
      const filterred = flattenNavigationList.filter(({ path, hidden, isLabel, hoistChildren }) => (
        path && !hidden && !isLabel && !hoistChildren && pathname.startsWith(path) && !path.startsWith(MANAGE_ROOT_PATH))
      )
      if (filterred.length) {
        return _.orderBy(filterred, [({ path }) => path.length], ['desc'])?.[0]
      }
    } // fawkes use the current logic
    let array = flattenNavigationList.filter(({ path, hidden, fixedLocationRoute }) =>
      !hidden && pathname.includes(path) &&
      (!pathname.includes(SWG_CONTAINER) || fixedLocationRoute)
    ).map(({ path, ...others }) => ({
      path, size: path.length,
      pos: pathname.indexOf(path),
      ...others
    }))
    array = _.orderBy(array, ['size'], ['desc'])
    array = _.orderBy(array, ['pos'], ['desc'])
    return array?.[0]
  }), [flattenNavigationList])
  const handleLocationChange = useCallback(({ pathname, search }) => {
    const key = pathname.split('/')[2]
    const container = GPCS_CONTAINERS[key]

    if (container) {
      changeConfigLocation({ container })
      updateRouteValue('locationRoute', key)
    }
    setSelectedItem(getSelectedItem(pathname))

    const menuKey = getKeyFromPath(pathname)
    setCurrentPath(pathname)
    if (search) {
      queryHistory[menuKey] = { [pathname]: search }
    }
    else {
      delete queryHistory[menuKey]
    }
  }, [getSelectedItem, changeConfigLocation, updateRouteValue])
  const goTo = useCallback((path) => {
    if ((path?.pathname || path) !== currentPath || window.location.search.length > 1) {
      history.push(path)
    }
  }, [currentPath])
  const contextValue = useMemo(() => ({
    goTo,
    currentPath,
    expandedId,
    setExpandedId,
    removeExpandedId,
    locationRoute,
    menuKey: menu?.key,
    isFavClickedPath,
    setIsFavClickedPath,
    selectedItem,
  }), [
    goTo,
    currentPath,
    expandedId,
    setExpandedId,
    removeExpandedId,
    locationRoute,
    menu?.key,
    isFavClickedPath,
    setIsFavClickedPath,
    selectedItem,
  ])

  // Storing last visited page in a menu
  useLayoutEffect(() => {
    const key = getKeyFromPath(currentPath)
    menuHistory[key] = currentPath
  }, [currentPath, menu.key])

  // Actions to be taken when a new menu is loaded
  useLayoutEffect(() => {
    const lastMenuPath = menu.forgetLastMenu ? undefined : (
      (menu.key && menuHistory[menu.key]) ||
      (menu.alternateKey && menuHistory[menu.alternateKey.startsWith('/') ? getKeyFromPath(menu.alternateKey) : menu.alternateKey]) ||
      (menu.path && menu.path !== '#' && menuHistory[getKeyFromPath(menu.path)])
    )
    const locPathName = window.location.pathname
    const locPathKey = getKeyFromPath(locPathName)
    if (menu.key && locPathKey === menu.key) {
      goToFirstLink = false
    }
    else if (lastMenuPath && _showSideMenu) {
      if (lastMenuPath !== locPathName) {
        const search = queryHistory[getKeyFromPath(lastMenuPath)]?.[lastMenuPath]
        goTo(search ? {
          pathname: lastMenuPath,
          search,
        } : lastMenuPath)
      }
      else {
        goToFirstLink = false
      }
    }
    else {
      goToFirstLink = true
    }
    idCounter = 1
  }, [menu.key, _showSideMenu])

  useEffect(() => {
    handleLocationChange(history.location)
    const unlisten = history.listen(handleLocationChange)
    return () => {
      unlisten()
    }
  }, [handleLocationChange])

  useEffect(() => {
    dispatch({
      type: 'INIT',
      payload: {
        favorites: _.get(main, 'loggedInUser.preference.config.favorites', {})
      }
    })
  }, [])

  return (
    <MenuContext.Provider value={contextValue}>
      {_showSideMenu && (
        <div className={'left-nav'}>
          <h2>{renderTitle(menu?.title)}</h2>
          <LeftNav favoriteState={state} dispatch={dispatch} item={{ children: menu?.children || [] }} main={main} pathAvailMap={pathAvailMap} pathDisabledMap={pathDisabledMap} />
        </div>
      )}
    </MenuContext.Provider>
  )
}

export default LeftNavWrap
